module.exports = __webpack_public_path__ + "static/solution8-c995b1a6ef0f7619de840ac06b877672.png";